export const MAZE_PASSAGE_DEFAULT_ROW_HEIGHT = 100;
const FONT_100_PASSAGE_ROW_HEIGHT = 158;
const FONT_150_PASSAGE_ROW_HEIGHT = 189;
const FONT_200_PASSAGE_ROW_HEIGHT = 225;

export const MAZE_PASSAGE_ROW_HEIGHT_BY_FONT_SIZE = {
    100: FONT_100_PASSAGE_ROW_HEIGHT,
    150: FONT_150_PASSAGE_ROW_HEIGHT,
    200: FONT_200_PASSAGE_ROW_HEIGHT,
};
export const getScrollStepSize = (isExtendedView, fontSizeScaleValue) =>
    (isExtendedView
        ? MAZE_PASSAGE_ROW_HEIGHT_BY_FONT_SIZE[fontSizeScaleValue]
        : MAZE_PASSAGE_DEFAULT_ROW_HEIGHT) * 2;
